module.exports = __webpack_public_path__ + "static/media/mastercard.7559f0a3.svg";